<template>
  <div class="vbox-container" :class="params.className" :style="{padding:params.padding}" ref="ct">
    <div class="vbox-row" v-for="(row,index) in params.rows" :key="index" :class="row.className"
         :style="{height:row.height,'padding-top':row.paddingTop,'paddingBottom':row.paddingBottom}"
         ref="rows"
    >
      <div class="vbox-item" v-for="item in row.items" :style="{width:item.width || '100%'}">
        <component :is="item.xtype" :params="item"></component>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'vbox',
    props:{
      params:Object
    },
    data(){
      return {}
    },
    mounted() {
      if (this.params.style) {
        this.appendStyle(this.$refs.ct, this.params.style);
      }
      this.params.rows.forEach((r,idx)=>{
        if(r.style){
          let div=this.$refs.rows[idx];
          this.appendStyle(div,r.style);
        }
      });
    },
    methods:{
      appendStyle(el,style){
        let oldStyle=$(el).attr("style");
        $(el).attr("style", oldStyle + "; " + style);
      }
    }
  }
</script>
<style scoped>
  .vbox-item{
    display:inline-block;
    height:100%;
    float:left;
  }
  .vbox-container{
    height:100%;
  }
  .vbox-row{
    overflow: auto;

  }
</style>



// WEBPACK FOOTER //
// src/common/components/extend/layout/vbox.vue